import { LoaderFunctionArgs } from "react-router-dom";

export const FirstLoginPasswordChangeLoader = async (args: LoaderFunctionArgs) => {

    return { token: args.params.token };

};